import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import configureStore from 'app/store';
import actions from 'app/types/action_types';
import inspirePagePayloadType from 'app/components/shared/InspirePage/inspirePagePayloadType';
import faqUnreleasedImageryPayloadType from 'app/components/getty/UnreleasedImagery/faqUnreleasedImageryPayloadType';
import headerPayloadType from 'app/components/istock/Header/headerPayloadType';
import heroBannersPayloadType from 'app/components/istock/HeroBanners/heroBannersPayloadType';
import videoEditorPayloadType from 'app/components/istock/VideoEditor/videoEditorPayloadType';
import videoLandingPayloadType from 'app/components/istock/VideoLanding/videoLandingPayloadType';
import initialState from 'app/initial_state';
import Providers from 'app/Providers';

const initLanding = (store, payload) => {
  store.dispatch({
    type: actions.INITIALIZE,
    payload,
  });
};

const App = ({ experiences, payload = {} as any, children }) => {
  const store = configureStore(initialState);
  initLanding(store, payload);

  const { routing, site, user } = payload;

  return (
    <Suspense>
      <Provider store={store}>
        <Providers
          user={user}
          experiences={experiences}
          routing={routing}
          site={site}
        >
          {children}
        </Providers>
      </Provider>
    </Suspense>
  );
};

// Video Editor payload only valid payload when this was created - landing
// will potentially need an initial state similar to ADP or else implement
// the purchase pattern of multiple incoming payloads per page.

// Landing - "Home" Also triggers App proptypes so cannot make payloads required at this time
// This is typescript so we I dont think we need to worry about propTypes
App.propTypes = {
  experiences: PropTypes.shape({}).isRequired,
  payload: PropTypes.oneOfType([
    inspirePagePayloadType,
    heroBannersPayloadType,
    videoEditorPayloadType,
    faqUnreleasedImageryPayloadType,
    videoLandingPayloadType,
    headerPayloadType,
  ]),
  children: PropTypes.node,
};

export default App;
